var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.506867 4.99996C0.326553 4.99741 0.158833 5.09214 0.067932 5.24789C-0.0229695 5.40364 -0.0229695 5.59626 0.067932 5.75201C0.158833 5.90775 0.326553 6.00249 0.506867 5.99994H17.4925C17.6729 6.00249 17.8406 5.90775 17.9315 5.75201C18.0224 5.59626 18.0224 5.40364 17.9315 5.24789C17.8406 5.09214 17.6729 4.99741 17.4925 4.99996H0.506867Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.506867 5.0215e-05C0.326553 -0.00249988 0.158833 0.0922361 0.067932 0.247982C-0.0229695 0.403728 -0.0229695 0.596354 0.067932 0.7521C0.158833 0.907845 0.326553 1.00258 0.506867 1.00003H17.4925C17.6729 1.00258 17.8406 0.907845 17.9315 0.7521C18.0224 0.596354 18.0224 0.403728 17.9315 0.247982C17.8406 0.0922361 17.6729 -0.00249988 17.4925 5.0215e-05H0.506867Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.506929 9.99987C0.326614 9.99732 0.158894 10.0921 0.067993 10.2478C-0.0229085 10.4035 -0.0229085 10.5962 0.067993 10.7519C0.158894 10.9077 0.326614 11.0024 0.506929 10.9998H17.4926C17.6729 11.0024 17.8406 10.9077 17.9315 10.7519C18.0224 10.5962 18.0224 10.4035 17.9315 10.2478C17.8406 10.0921 17.6729 9.99732 17.4926 9.99987H0.506929Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobile-menu.d4741ec877eb2ce2a1220aac259e26e1.svg";
export { ForwardRef as ReactComponent };